import React from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import { CommonChrome } from '@solarwinds-cloud/cloud-ui';
import SearchResultsContainer from './search-results-container';

const CATEGORIES = [
  {
    name: 'All',
  },
  {
    name: 'Groups',
  },
  {
    name: 'Saved Searches',
  },
  {
    name: 'Systems',
  },
];

class Search extends React.PureComponent {
  static propTypes = {
    inverted: PropTypes.bool,
    maxResults: PropTypes.number,
    searchPhrase: PropTypes.string,
  };

  itemToString = (item) => {
    return item ? item.name : '';
  };

  searchKeyBinding = (e) => {
    // viewer search triggers using '/', so trigger with 's' instead
    // TODO: use constants/shortcuts
    return e.which === 83;
  };

  getPlaceholder() {
    const defaultPlaceholder = 'Search groups, systems, and saved searches';
    const placeholders = {
      Groups: 'Search groups',
      'Saved Searches': 'Search saved searches',
      Systems: 'Search systems',
    };

    return placeholders[this.props.searchCategory] || defaultPlaceholder;
  }

  onChange = ({ item }) => {
    this.props.resetSearch();
    window.location = item.url;
  };

  render() {
    const { inverted, maxResults, searchCategory, searchPhrase } = this.props;
    const isOpen = !!searchPhrase;

    return (
      <Downshift
        id="search"
        isOpen={isOpen}
        itemToString={this.itemToString}
        onChange={this.onChange}
      >
        {({
          getInputProps,
          getItemProps,
          getMenuProps,
          getRootProps,
          highlightedIndex,
          reset,
        }) => {
          return (
            <CommonChrome.NavSearch
              {...getRootProps({ refKey: 'innerRef' })}
              categories={CATEGORIES}
              inputProps={getInputProps()}
              inverted={inverted}
              placeholder={this.getPlaceholder()}
              searchKeyBinding={this.searchKeyBinding}
              onChangeSearch={reset}
              onChangeSearchCategory={reset}
            >
              <CommonChrome.NavSearch.Results {...getMenuProps()}>
                {isOpen && (
                  <SearchResultsContainer
                    getItemProps={getItemProps}
                    highlightedIndex={highlightedIndex}
                    maxResults={maxResults}
                    searchCategory={searchCategory}
                    searchPhrase={searchPhrase}
                  />
                )}
              </CommonChrome.NavSearch.Results>
            </CommonChrome.NavSearch>
          );
        }}
      </Downshift>
    );
  }
}

export default (props) => (
  <CommonChrome.ContextConsumer>
    {({ resetSearch, searchCategory, searchPhrase }) => (
      <Search
        {...props}
        resetSearch={resetSearch}
        searchCategory={searchCategory}
        searchPhrase={searchPhrase}
      />
    )}
  </CommonChrome.ContextConsumer>
);
